import { Component, OnInit, ViewChild, enableProdMode } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DxDataGridComponent, DxScrollViewComponent, DxDataGridModule, DxSelectBoxModule, DxCheckBoxModule, DxTemplateModule } from 'devextreme-angular';
import { FusService } from '../../../services/formulacion/fus.service';
import { ReversionService } from '../../../services/formulacion/reversion.service';
import { UtilHelper } from '../../../_helpers/util';
import { environment } from '../../../../environments/environment';
declare var jQuery: any;
declare var toastr;

@Component({
  selector: 'app-fus-jue-ufin',
  templateUrl: './fus-jue-ufin.component.html',
  styles: []
})
export class FusJueUfinComponent implements OnInit {  
  
    @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
    tipo_agregacion_id: number = 1;
    nroFus: string;
    fuses: any[];
    fusesAprobar: any[] = [];
    fus: any;
    fusReversion: any;
    estadosFilter: any = [];
    estado: number = 14;
    popupVisibleA: boolean = false;
    popupVisibleO: boolean = false;
    popupVisibleR: boolean = false;
    model: any;
    estados: any[] = [{ id: 3, descripcion: 'Observado' }, { id: 4, descripcion: 'Aprobado' }];
    clicked: boolean = false;
    baseUrl = environment.apiEndpoint;
    baseUrld = environment.apiEndpoint.substring(0, environment.apiEndpoint.length - 4);
    file: File = null;
    maxFileSize = 2097152;
    typeFiles = ['application/pdf', 'image/jpeg', 'image/png'];    
    fechaRM = new Date();
    jusReversion = false;
    hasError: any;
  
    constructor(private route: ActivatedRoute, private _fs: FusService, private _rs: ReversionService) {
      this.tipo_agregacion_id = 1;
      this.getEstadosByUsuario();
      this.resetErrors();
    }
  
    ngOnInit() {
    }
  
    getEstadosByUsuario() {
      this._fs.getFusEstadosByUsuario().subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.estadosFilter = result.data;
            this.getListFus(this.estado, this.tipo_agregacion_id);
          }
          else { this.estadosFilter = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    getListFus(id: number, tipo_agregacion_id: number) {
      this._fs.getListFusByEstadoId(id, tipo_agregacion_id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) { this.fuses = result.data; }
          else { this.fuses = []; }
        },
        (error) => { console.log('Error', error); });
    }
  
    onToolbarPreparing(e) {
      e.toolbarOptions.items.unshift({
        location: 'before',
        template: 'acciones'
      },
        {
          location: 'before',
          widget: 'dxButton',
          options: {
            icon: 'refresh',
            text: 'Actualizar',
            onClick: this.refreshDataGrid2.bind(this)
          }
        });
    }
  
    refreshDataGrid(e) {
      this.getListFus(e.value, this.tipo_agregacion_id);
      this.dataGrid.instance.refresh();
      this.estado = e.value;
    }
  
    refreshDataGrid2(e) {
      this.getListFus(this.estado, this.tipo_agregacion_id);
      this.dataGrid.instance.refresh();
    }
  
    aprobarFUS() {
      this.clicked = true;
      this.model.fechaC31 = this.convertDate(this.fechaRM);
      this.model.fuses = this.fusesAprobar;
      if (this.validSave()) {
        this._fs.postFusApruebaPtto(this.model, this.file).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {            
              this.getListFus(this.estado, this.tipo_agregacion_id);
              this.dataGrid.instance.refresh();
              toastr.success('Datos guardados correctamente.');
              this.clicked = false;
            }
            if (result.status == 201) {                    
              toastr.warning('Le falta un total de: ' + result.data); 
              this.clicked = false;
            }
            this.popupVisibleA = false;
          });
      }
    }
  
    observarFUS() {
      if (this.validObs()) {
        this.clicked = true;
        this._fs.putFusObservaPtto(this.model).subscribe(
          response => {
            let result = UtilHelper.responses(response);
            if (result.status == 200) {
              this.getListFus(this.estado, this.tipo_agregacion_id);
              this.dataGrid.instance.refresh();
              toastr.success('Datos guardados correctamente.');
              this.clicked = false;
            }
            this.popupVisibleO = false;
          });
      }
    }
  
    validSave() {
      let res = true;
      if (!UtilHelper.validator(this.model.observacion, 'text')) {
        this.hasError.observacion = true; res = false;
      }
      if (!UtilHelper.validator(this.model.nroC31, 'text')) {
        this.hasError.nroC31 = true; res = false;
      }
      if (!UtilHelper.validator(this.model.montoC31, 'text')) {
        this.hasError.montoC31 = true; res = false;
      }
      if (!UtilHelper.validator(this.model.fechaC31, 'ddmmyyyy')) {
        this.hasError.fechaC31 = true; res = false;
      }
      if (this.file != null) {
        if (this.file.size > this.maxFileSize) {
          toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
          this.hasError.file = true; res = false;
        }
        if (this.typeFiles.indexOf(this.file.type) == -1) {
          toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
          this.hasError.file = true; res = false;
        }
      }
      else {
        this.hasError.file = true; res = false;
      }
      return res;
    }
  
    validObs() {
      let res = true;
      if (!UtilHelper.validator(this.model.observacion, 'text')) {
        this.hasError.observacion = true; res = false;
      }
      return res;
    }
  
    resetErrors() {
      this.model = { id: 0, nroC31: '', fechaC31: '', montoC31: '', observacion: '', fuses: [], file: null };
      this.hasError = { nroC31: false, fechaC31: false, montoC31: false, observacion: false, file: false };
    }
  
    showModalAprobar(data: any) {      
      this.resetErrors();
      this.file = null;
      jQuery("#file").val('');
      this.popupVisibleA = true;
      this.model.id = data.id;
      this.model.montoC31 = data.monto_fus;
      this.model.nroC31 = data.nro_c31;      
    }
  
    showModalObs(id: number) {
      this.resetErrors();
      this.popupVisibleO = true;
      this.model.id = id;
    }
  
    handleFileInput(files: FileList) {
      this.file = files.item(0);
      if (this.file != null) {
        if (this.file.size > this.maxFileSize) {
          toastr.warning('El tamaño del archivo no debe exceder los 2MB.');
        }
        if (this.typeFiles.indexOf(this.file.type) == -1) {
          toastr.warning('Formato de archivo no válido, los permitidos son PDF, JPG y PNG.');
        }
      }
    }
  
    convertDate(date: Date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      let nd = dd.toString();
      let nm = mm.toString();
      var yyyy = date.getFullYear(); if (dd < 10) { nd = '0' + dd } if (mm < 10) { nm = '0' + mm }
      return nd + '/' + nm + '/' + yyyy;
    }
  
    getFusReversionesById(id: string) {
      this.resetErrors();
      this._rs.getFusReversionesById(id).subscribe(
        (response) => {
          let result = UtilHelper.responses(response);
          if (result.status == 200) {
            this.fusReversion = result.data;
            this.popupVisibleR = true;
          }
        },
        (error) => { console.log('Error', error); });
    }
  
    
  }
  